import React from 'react';
// import Button from '@mui/material/Button';
import weatherPhoto from '../Mausam.png';
import expenseTracker from '../expense-tracker-app.png';
import smartBriefs from '../smartbriefs.png';
// import { createTheme } from '@mui/material/styles';

  // const buttonTheme = createTheme({
  //   palette: {
  //     mode: 'light',
  //   },
  // });

const Projects = () => {
  return (
    <div className='projects'>
      <h2>Projects</h2>
      <div className="projects-grid">
        <a className='project-card-container' href='https://mausam-delta.vercel.app/' target='_blank' rel='noopener noreferrer'>
          <div className='project-card'>
            <img src={weatherPhoto} alt='Mausam Weather App' />
            <div className='project-overlay'>
              <div className='project-title'>Mausam Weather App</div>
                <p>This app was build using HTML, React, SASS, REST API from OpenWeather API</p>
            </div>
          </div>
          <div  className='mobile-project-title'>
            <span>Mausam Weather App</span>
          </div>
        </a> 

        <a className='project-card-container' href='https://expense-tracker-gilt-mu.vercel.app/' target='_blank' rel='noopener noreferrer'>
          <div className='project-card'>
            <img src={expenseTracker} alt='Expense Tracker' />
            <div className='project-overlay'>
              <div className='project-title'>Expense Tracker</div>
                <p>This app was build using HTML,Vanilla JavaScript, React, SASS, REST API from OpenWeather API, Node.js and Material UI</p>
            </div>
          </div>
          <div  className='mobile-project-title'>
            <span>Expense Tracker App</span>
          </div>
        </a>  

        <a className='project-card-container' href='https://github.com/sahibsidhu/SmartBriefs' target='_blank' rel='noopener noreferrer'>
          <div className='project-card'>
            <img src={smartBriefs} alt='SmartBriefs' />
            <div className='project-overlay'>
              <div className='project-title'>SmartBriefs</div>
              <p>This app was build using HTML,Vanilla JavaScript, React, TailwindCSS, REST API from AlanAI, Node.js and Material UI</p>
            </div>
          </div>
          <div  className='mobile-project-title'>
            <span>SmartBriefs - Ai News Reader App</span>
          </div>
        </a> 

        {/* <a className='project-card-container' href='https://expense-tracker-gilt-mu.vercel.app/' target='_blank' rel='noopener noreferrer'>
          <div className='project-card'>
            <img src={expenseTracker} alt='Expense Tracker' />
            <div className='project-overlay'>
              <div className='project-title'>Expense Tracker</div>
              <p>This app was build using HTML,Vanilla JavaScript, React, SASS, REST API from OpenWeather API, Node.js and Material UI</p>
            </div>
          </div>
          <div  className='mobile-project-title'>
            <span>Mausam Weather App</span>
          </div>
        </a> 

        <a className='project-card-container' href='https://expense-tracker-gilt-mu.vercel.app/' target='_blank' rel='noopener noreferrer'>
          <div className='project-card'>
            <img src={expenseTracker} alt='Expense Tracker' />
            <div className='project-overlay'>
              <div className='project-title'>Expense Tracker</div>
              <p>This app was build using HTML,Vanilla JavaScript, React, SASS, REST API from OpenWeather API, Node.js and Material UI</p>
            </div>
          </div>
          <div  className='mobile-project-title'>
            <span>Mausam Weather App</span>
          </div>
        </a> 
        <a className='project-card-container' href='https://expense-tracker-gilt-mu.vercel.app/' target='_blank' rel='noopener noreferrer'>
          <div className='project-card'>
            <img src={expenseTracker} alt='Expense Tracker' />
            <div className='project-overlay'>
              <div className='project-title'>Expense Tracker</div>
              <p>This app was build using HTML,Vanilla JavaScript, React, SASS, REST API from AlanAI, Node.js and Material UI</p>
            </div>
          </div>
          <div  className='mobile-project-title'>
            <span>Mausam Weather App</span>
          </div>
        </a>  */}
      </div>
      {/* <div className="project-btn-container">
      <ThemeProvider theme={buttonTheme}>
        <Button variant='contained' size='large' className='projectButton'>
                      View all projects
                    </Button>
        </ThemeProvider>
      </div> */}
      <div className="divider"></div>
    </div>
  );
};

export default Projects;
